import { useState } from 'react';
import Router from 'next/router';
import PropTypes from 'prop-types';
import _ from 'lodash';

import FullScreenDialog from '../shared/fulll-screen-dialog.component';
import WaitingListDialogStepper from './waiting-list-dialog-stepper.component';
import WaitingListDetailsForm from './waiting-list-details-form.component';
import WaitingListDates from './waiting-list-dates.component';
import { Button } from '../shared';

const steps = {
    DETAILS: 0,
    DATES: 1,
    CONFIRMATION: 2,
};

const WaitingListDialog = (props) => {
    const { isOpen, setIsOpen } = props;
    const [currentStep, setCurrentStep] = useState(steps.DETAILS);
    const [formData, setFormData] = useState(null);

    const renderStepper = () => {
        return <WaitingListDialogStepper activeStep={currentStep} />;
    };

    const onFormSubmit = (data) => {
        setFormData(data);
    };

    const goToDatesStep = () => {        
        setCurrentStep(steps.DATES);
    };

    const goToConfirmationStep = () => {
        setCurrentStep(steps.CONFIRMATION);
    };

    const setIsOpenAndGoBackToStepOne = () => {
        setCurrentStep(steps.DETAILS);
        setIsOpen();
    };

    const renderDetailsForm = () => {
        return (
            <>
                <h4 className='waiting-list-dialog-header4'>Join Waiting List</h4>
                <p style={{ fontWeight: 'bold', marginBottom: 4 }}>Your Deets</p>
                <p style={{ fontWeight: 'normal', marginBottom: 39 }}>
                    Please enter your name & contact details for the next available space
                </p>
                <WaitingListDetailsForm nextStep={goToDatesStep} onFormSubmit={onFormSubmit} />
            </>
        );
    };

    const renderDatesForm = () => {        
        return (
            <>
                <h4 className='waiting-list-dialog-header4'>Preferred Date</h4>
                <p style={{ fontWeight: 'normal', marginBottom: 39 }}>Choose the month you want to stay here</p>
                <WaitingListDates                    
                    firstName={_.get(formData, 'firstName')}
                    lastName={_.get(formData, 'lastName')}
                    phoneNumber={_.get(formData, 'contactNumber')}
                    email={_.get(formData, 'email')}
                    nextStep={goToConfirmationStep}
                />                
            </>
        ); 
    };

    const onHomeClick = () => {
        Router.push('/').then(() => window.scrollTo(0, 0));
    };

    const renderConfirmation = () => {
        return (
            <>
                <h4 className='waiting-list-dialog-header4'>You&apos;re On The List</h4>
                <p style={{ fontWeight: 'normal', marginBottom: 39 }}>
                    Thanks for choosing HOMii. We will be in touch as soon as space is available.
                </p>
                <Button id="waiting-list-back-home-button" variant="contained" color="primary" onClick={onHomeClick}>
                    Back Home
                </Button>            
            </>           
        );
    };

    const renderStep = () => {
        switch (currentStep) {
            case steps.DETAILS:
                return renderDetailsForm();
            case steps.DATES:
                return renderDatesForm();
            case steps.CONFIRMATION:
                return renderConfirmation();
            default:
                return renderDetailsForm();
        }
    };

    return (
        <FullScreenDialog
            isOpen={isOpen}
            setIsOpen={setIsOpenAndGoBackToStepOne}
            Stepper={renderStepper()}
        >
            <div className='container-root container-root-maxWidthLg' id="waiting-list-dialog-container">
                <div className='main-grid-container'>
                    <div className='main-grid-item main-grid-lg-4'>
                        {renderStep()}
                    </div>
                </div>
            </div>
        </FullScreenDialog>
    );
};

export default WaitingListDialog;

WaitingListDialog.propTypes = {
    isOpen: PropTypes.bool,

    sendWaitingList: PropTypes.func,
    setIsOpen: PropTypes.func,
};

